module.exports = ".mat-column-DNI,\n.mat-column-NombreApellidos,\n.mat-column-Respuesta {\n  display: flex;\n  font-size: 11.5px; }\n"